import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import { SurveyStatusV2Service } from "../../../survey-status-v2.service";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  tipoCorreo: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalComponent>,
    private translateSrv: TranslateService,
    private surveyServ: SurveyStatusV2Service
  ) { }

  ngOnInit() {
    console.log("datosRecibidos:",this.datos);
  }

  eligeTipo(){
    console.log('this.tipoCorreo',this.tipoCorreo);

    if (this.tipoCorreo!=undefined) {
      Swal.fire({
        title: this.translateSrv.instant('HISTORIAL_MAILS.MODALES.CONFIRMAR'),
        icon: 'question',
        confirmButtonText: this.translateSrv.instant('HISTORIAL_MAILS.MODALES.SI'),

        showCancelButton: true,
      reverseButtons: true,
        cancelButtonText: this.translateSrv.instant('HISTORIAL_MAILS.MODALES.NO'),
        cancelButtonColor: '#004858'
      }).then((result) => {
        if (result.value) {

          this.salir(this.tipoCorreo);
        }
      });
    }else{
      Swal.fire({
        title: this.translateSrv.instant('HISTORIAL_MAILS.MODALES.WAR_SEL_MAI'),
        icon: 'warning',
        confirmButtonText: 'OK',
      })

    }

  }

  salir(dato?:number){
    this.dialogRef.close(dato);
  }

}
